module.exports = __webpack_public_path__ + "c2f41a9aa790c86aa49041185b7f8849.png";